var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data && _vm.data.length > 0)?_c('div',{staticClass:"pie",attrs:{"id":_vm.pieId}}):_c('div',{staticClass:"loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }